import { createSelector } from 'reselect';
import ReservationUtils from 'utils/reservation-utils';
const getUserVehicles = (state) => state.user.data?.vehicles || [];
// Useful for dealing with vehicle selection forms, so not constantly
// converting to string when checking against an input value
export const getTransformedUserVehicles = createSelector([getUserVehicles], vehicles => {
    if (!vehicles || vehicles.length === 0) {
        return [];
    }
    return vehicles
        .map(v => ({
        ...v,
        vehicleProfileId: String(v.vehicleProfileId),
    }))
        .filter(v => v.licensePlateValue !==
        ReservationUtils.DONT_KNOW_LICENSE_VALUE);
});
const getUserCards = (state) => state.user.data?.creditCards || [];
const getUserBraintreeCard = (state) => state.user.data?.paypalCard;
export const getUserPaymentMethods = createSelector([getUserCards, getUserBraintreeCard], (cards, paypalCard) => {
    const allPaymentMethods = [...cards];
    if (paypalCard) {
        allPaymentMethods.push(paypalCard);
    }
    return allPaymentMethods;
});
